"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const gatsby_1 = require("gatsby");
const utils_1 = require("../utils");
const elementStyles = (props) => ({
    cursor: 'pointer',
    textDecoration: props.underlined ? 'underlined' : 'none',
    color: props.color,
    ...(0, utils_1.createStyles)(props.styles),
});
const Anchor = styled_1.default.a(elementStyles);
const GatsbyAnchor = (0, styled_1.default)(gatsby_1.Link)(elementStyles);
const Link = (props) => {
    const isExternalLink = props.external || /^(mailto:|tel:)/.test(props.to);
    if (props.openNewTab || isExternalLink) {
        return ((0, jsx_runtime_1.jsx)(Anchor, { "aria-label": props['aria-label'], className: props.className, href: props.to, onClick: props.onClick, rel: "noreferrer", styles: props.styles, target: props.openNewTab ? '_blank' : undefined, underlined: props.underlined, color: props.color, children: props.children }));
    }
    return ((0, jsx_runtime_1.jsx)(GatsbyAnchor, { "aria-label": props['aria-label'], className: props.className, onClick: props.onClick, styles: props.styles, to: props.to, underlined: props.underlined, color: props.color, children: props.children }));
};
exports.Link = Link;
